export enum BudgetStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CHANGED = 'CHANGED',
  COUNTER_PROPOSAL = 'COUNTER_PROPOSAL',
}

export const BudgetStatusLabelMap: Record<BudgetStatusEnum, string> = {
  [BudgetStatusEnum.PENDING]: 'Pendente',
  [BudgetStatusEnum.APPROVED]: 'Aprovado',
  [BudgetStatusEnum.REJECTED]: 'Recusado',
  [BudgetStatusEnum.CHANGED]: 'Alterado',
  [BudgetStatusEnum.COUNTER_PROPOSAL]: 'Contraproposta',
};

export const getBudgetStatusLabel = (status: BudgetStatusEnum | string): string => {
  if (status in BudgetStatusLabelMap) {
    return BudgetStatusLabelMap[status as BudgetStatusEnum];
  }
  return status;
};

export const BudgetStatusFilterMap: Record<string, BudgetStatusEnum> = {
  Pendente: BudgetStatusEnum.PENDING,
  Aprovado: BudgetStatusEnum.APPROVED,
  Recusado: BudgetStatusEnum.REJECTED,
  Alterado: BudgetStatusEnum.CHANGED,
  Contraproposta: BudgetStatusEnum.COUNTER_PROPOSAL,
};

export const getBudgetStatusFilter = (label: string): BudgetStatusEnum => {
  if (label in BudgetStatusFilterMap) {
    return BudgetStatusFilterMap[label];
  }
  return BudgetStatusFilterMap.PENDING;
};

export enum BudgetStatusFilterEnum {
  SENT = "Enviado",
  UPDATED = "Alterado",
  COUNTER_PROPOSED = "Contraproposta",
  PENDING = "Pendente",
  APPROVED = "Aprovado",
  APPROVED_BY_FACTORY = "Aprovado pela fábrica",
  REJECTED = "Recusado",
}
